import { FC, ReactNode } from 'react';
import { AnimatedBadge } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';

export type BadgeType = 'new' | 'beta' | 'free' | ReactNode;

export const PromoBannerBadge: FC<{ badgeType: BadgeType }> = ({ badgeType }) => {
  const { t } = useTranslation('highValueAdoption');

  switch (badgeType) {
    case 'new':
      return <AnimatedBadge label={t('New')} />;
    case 'beta':
      return (
        <AnimatedBadge
          label={t('Beta')}
          animated={false}
          bgColor={theme.colors.indigo50}
          highlightColor={theme.colors.indigo20}
        />
      );
    case 'free':
      return (
        <AnimatedBadge
          label={t('Free')}
          animated={false}
          bgColor='var(--fabric-color-accent-seaweed-alpha-muted)'
          textColor='var(--fabric-color-accent-seaweed-alpha-emphasis)'
        />
      );
    case undefined:
      return null;
    default:
      return badgeType;
  }
};
